package crashreporting

internal fun fallbackCrashReporter(config: CrashReporterConfig): CrashReporter =
    if (config.debug) LoggingCrashReporter(config.logger) else NoOpCrashReporter

expect fun createCrashReporter(config: CrashReporterConfig): CrashReporter
